import { Center, Loader } from '@mantine/core';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useToken } from '@/auth/session';
import { canManage, useMe } from '@/auth/useMe';
import { AppLayout } from '@/components/AppLayout';
import { BroadcastsScreen } from '@/screens/BroadcastsScreen';
import { HomeScreen } from '@/screens/HomeScreen';
import { LocationsScreen } from '@/screens/LocationsScreen';
import { LockerDetailScreen } from '@/screens/LockerDetailScreen';
import { LockersScreen } from '@/screens/LockersScreen';
import { ForbiddenScreen, LoginScreen } from '@/screens/LoginScreen';
import { ProductsScreen } from '@/screens/ProductsScreen';
import { PromoScreen } from '@/screens/PromoScreen';
import { UsersScreen } from '@/screens/UsersScreen';
import { useAdminSocket } from '@/ws/useAdminSocket';

function AuthorizedApp() {
    useAdminSocket();
    return (
        <Routes>
            <Route element={<AppLayout />}>
                <Route index element={<HomeScreen />} />
                <Route path="lockers" element={<LockersScreen />} />
                <Route path="lockers/:lockerId" element={<LockerDetailScreen />} />
                {/* Старые ссылки вида /locker/<id> (из уведомлений, закладок). */}
                <Route path="locker/:lockerId" element={<LegacyLockerRedirect />} />
                <Route path="promo-codes" element={<PromoScreen />} />
                <Route path="products" element={<ProductsScreen />} />
                <Route path="locations" element={<LocationsScreen />} />
                <Route path="users" element={<UsersScreen />} />
                <Route path="notifications" element={<BroadcastsScreen />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
        </Routes>
    );
}

function LegacyLockerRedirect() {
    const id = window.location.pathname.split('/').pop() || '';
    return <Navigate to={`/lockers/${id}`} replace />;
}

export function App() {
    const token = useToken();
    const me = useMe();

    if (!token) return <LoginScreen />;
    if (me.isLoading) {
        return (
            <Center mih="100dvh">
                <Loader />
            </Center>
        );
    }
    if (me.isError) return <LoginScreen />;
    if (!canManage(me.data)) return <ForbiddenScreen />;
    return <AuthorizedApp />;
}
